// Example: 2018-11-20 18:04:34
import { WeekDay } from '../types/commons';

// Example: mer. 22 janv.
export const WEEKDAY_DAY_MONTH_FORMAT = 'ddd DD MMM';

// Example: lundi
export const DAY_MINOR_FORMAT = 'dddd';

export const STANDARD_DATE_FORMAT = 'YYYY-MM-DD';

export const ANDROID_DATE_TIME_FORMAT = 'dddd DD/MM/YYYY HH:mm';

export const STANDARD_DATE_FORMAT_REGEXP = /^\d{2}\/\d{2}\/\d{4}$/;

export const WEEK_DAYS: { name: WeekDay; index: number }[] = [
  { name: 'monday', index: 1 },
  { name: 'tuesday', index: 2 },
  { name: 'wednesday', index: 3 },
  { name: 'thursday', index: 4 },
  { name: 'friday', index: 5 },
  { name: 'saturday', index: 6 },
  { name: 'sunday', index: 0 },
];

export const ISO_WEEK_DAYS: { name: WeekDay; index: number }[] = [
  { name: 'monday', index: 1 },
  { name: 'tuesday', index: 2 },
  { name: 'wednesday', index: 3 },
  { name: 'thursday', index: 4 },
  { name: 'friday', index: 5 },
  { name: 'saturday', index: 6 },
  { name: 'sunday', index: 7 },
];
